module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "relative mb-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "absolute display-flex align-center justify-space-between profile__header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/dot.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlanMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/arrow-down-white.svg"),
      "width": "27"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'CommunityMobile'
        })
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width my-3 px-4"
  }, [_c('v-btn', {
    staticClass: "profile__btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'PlanMobile'
        })
      }
    }
  }, [_vm._v("\n      Follow\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "profile__btn",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ChatRoomMobile'
        })
      }
    }
  }, [_vm._v("\n      Chat live!\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll my-4 px-4"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "profile__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4",
      class: {
        'bg-white text-black': item.active
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-16 font-weight-700 mt-2 px-4"
  }, [_vm._v("Albums")]), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  })), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "horizontal-scroll px-4"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "horizontal-scroll__item mr-2 mb-2"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "font-15 font-weight-500 text-white"
    }, [_vm._v("Album")]), _vm._v(" "), _c('div', {
      staticClass: "text-grey-4 font-15 font-weight-500"
    }, [_vm._v("Artist name")])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/you.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute profile__username"
  }, [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/profile.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile__username__name"
  }, [_c('span', [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/icon/check-circle.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "profile__username__type"
  }, [_vm._v("@salva • 423.2k Followers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_3.jpg"),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-2 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-16 font-weight-700"
  }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_5.png"),
      "width": "151",
      "height": "151"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between align-center mt-2 px-4"
  }, [_c('div', {
    staticClass: "text-poppins-16 font-weight-700"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('div', {
    staticClass: "see-all font-weight-500"
  }, [_vm._v("See All")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/library_6.jpg"),
      "width": "151",
      "height": "151"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c73cf4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/profile.vue
// module id = 1784
// module chunks = 180